import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const caseSectionTabs = {
  DETAILS: 'details',
  RESOURCES: 'resources',
  CLINICAL: 'clinical',
  LOG: 'log',
  ACCESS: 'access',
  LOGISTICS: 'logistics',
  LOCATION_TRACKING: 'location-tracking',
} as const;

export type CaseSectionTabKey = (typeof caseSectionTabs)[keyof typeof caseSectionTabs];

type CaseSectionTabsState = {
  activeSectionTabsByCase: Record<string, CaseSectionTabKey>;
  setActiveSectionTab: (caseId: string, tab: CaseSectionTabKey) => void;
};

export const useCaseSectionTabsStore = create<CaseSectionTabsState>()(
  persist(
    (set) => ({
      activeSectionTabsByCase: {},
      setActiveSectionTab: (caseId, tab) =>
        set((state) => ({
          activeSectionTabsByCase: {
            ...state.activeSectionTabsByCase,
            [caseId]: tab,
          },
        })),
    }),
    {
      name: 'case-section-tabs',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        activeSectionTabsByCase: state.activeSectionTabsByCase,
      }),
    },
  ),
);
